import { compose } from "recompose";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded, isEmpty } from "react-redux-firebase";
import { deleteCustomer } from "actions/customers/customersActions";
import { getCustomerDetails } from "./selectors/Customers.Selector";
import CustomersShow from "components/Customers/CustomersShow";

const mapStateToProps = (state, ownProps) => {
  const { firestore, firebase } = state;
  const customers = state.firestore.data.customers;
  const regions = firestore.data.regions;
  const equipments = firestore.data.equipments;

  const customer = getCustomerDetails(state, ownProps);

  const auth = firebase.auth;
  const error = state.customers.error;

  const isLoading =
    !isLoaded(customers) && !isLoaded(regions) && !isLoaded(equipments);
  const isDataEmpty = isEmpty(customer);
  return {
    isLoading: isLoading,
    isEmpty: isDataEmpty,
    customer: customer,
    equipments: equipments,
    auth: auth,
    error: error
  };
};

export default compose(
  firestoreConnect([
    { collection: "customers" },
    { collection: "regions" },
    { collection: "equipments" },
    { collection: "agreements" }
  ]),
  connect(mapStateToProps, { deleteCustomer }),
)(CustomersShow);
